module.exports = __webpack_public_path__ + "img/252235c.png";